// Escapes a string for literal use inside a RegExp. Covers every character with meaning in a pattern or a character
// class, so an escaped value is safe in both positions.
export const escapeRegex = (value) => {
  return String(value ?? '').replace(/[.*+?^${}()|[\]\\\-/]/g, '\\$&');
};
